import http from "../http";

export const getPackagingMasters = async () => {
    return await http.get('/packing-master');
  }